// ── rb-wrapin-pdp-hide (added 2026-06-09) ───────────────────────────────────
// Hide Wrapin widget on PDPs that have variant-based letter selector
(function () {
  var HIDE_PDP_HANDLES = ["ciondolo-lettera-semplice-novita", "ciondolo-lettera-pave-novita","collana-initial-pave","collana-initial-simply",
  "ciondolo-brilla-come-una-stella"];
  var path = location.pathname.toLowerCase();
  var match = HIDE_PDP_HANDLES.some(function(h){ return path.indexOf("/products/" + h) !== -1; });
  if (!match) return;
  function hide() {
    document.querySelectorAll(".ptw-meta-json").forEach(function(el){ el.remove(); });
    document.querySelectorAll("[class*='ptw-'], [class^='ptw-'], [id^='ptw-']").forEach(function(el){
      el.style.setProperty("display", "none", "important");
    });
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", hide); else hide();
  new MutationObserver(hide).observe(document.documentElement, { childList: true, subtree: true });
})();
/**
 * rb-wrapin-guard
 *
 * If a wrapin/gift-wrap €0 placeholder line item exists in cart WITHOUT its
 * parent product (e.g. customer removed the parent from the drawer), remove
 * the placeholder automatically and toast. Prevents bug like order #14141
 * (customer paid €0 for a personalization without the actual product).
 *
 * UI annotation (showing "Personalizzazione: X" under the parent) is done
 * server-side in cart-drawer.liquid via Liquid, NOT here.
 *
 * Triggers: fetch/XHR interceptor on cart endpoints, DOM ready, drawer open.
 */
(function () {
  "use strict";

  var PLACEHOLDER_HANDLE = "gift-wrap";
  var PLACEHOLDER_VENDOR = "wrapin";
  var PLACEHOLDER_TITLE_LC = "scrivi qui la tua personalizzazione";
  var lastCheckAt = 0;

  function normTitle(s) { return (s || "").trim().toLowerCase(); }

  function isPlaceholder(item) {
    return (
      item.handle === PLACEHOLDER_HANDLE ||
      item.vendor === PLACEHOLDER_VENDOR ||
      normTitle(item.product_title) === PLACEHOLDER_TITLE_LC
    ) && Number(item.price) === 0;
  }

  function isOrphan(placeholder, allItems) {
    var pn = (placeholder.properties || {})["Product Name"] || (placeholder.properties || {})["product_name"];
    if (!pn) return false;
    var t2 = normTitle(pn);
    var parentExists = allItems.some(function (li) {
      if (li.id === placeholder.id) return false;
      var t1 = normTitle(li.product_title);
      return t1 === t2 || t1.indexOf(t2) !== -1 || t2.indexOf(t1) !== -1;
    });
    return !parentExists;
  }

  function removeLineItem(key) {
    return fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "X-Requested-With": "XMLHttpRequest" },
      body: JSON.stringify({ id: key, quantity: 0 }),
    }).then(function (r) { return r.json(); });
  }

  function showToast(msg) {
    try {
      var t = document.createElement("div");
      t.textContent = msg;
      t.style.cssText = "position:fixed;left:50%;bottom:24px;transform:translateX(-50%);background:#1A1A1A;color:#fff;padding:12px 18px;font-size:13px;font-family:-apple-system,'Segoe UI',sans-serif;letter-spacing:0.01em;z-index:99999;box-shadow:0 6px 22px rgba(0,0,0,.18);max-width:90vw;text-align:center;line-height:1.45;";
      document.body.appendChild(t);
      setTimeout(function () { t.style.transition = "opacity .4s"; t.style.opacity = "0"; }, 5000);
      setTimeout(function () { t.remove(); }, 5500);
    } catch (_) { /* ignore */ }
  }

  function refreshCartDrawer() {
    try {
      if (window.Alpine && Alpine.store && Alpine.store("xMiniCart") && Alpine.store("xMiniCart").reLoad) {
        Alpine.store("xMiniCart").reLoad();
      } else {
        window.dispatchEvent(new CustomEvent("cart:refresh"));
      }
    } catch (_) { /* ignore */ }
  }

  function checkCart() {
    var now = Date.now();
    if (now - lastCheckAt < 600) return;
    lastCheckAt = now;
    return fetch("/cart.js", { headers: { "Accept": "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart || !cart.items || !cart.items.length) return;
        var orphans = cart.items.filter(function (i) { return isPlaceholder(i) && isOrphan(i, cart.items); });
        if (orphans.length === 0) return;
        var p = Promise.resolve();
        orphans.forEach(function (o) {
          p = p.then(function () {
            return removeLineItem(o.key || o.id).then(function () {
              var pn = (o.properties && o.properties["Product Name"]) || "—";
              showToast("Personalizzazione \"" + pn + "\" rimossa: il prodotto non era nel carrello.");
            });
          });
        });
        return p.then(refreshCartDrawer);
      })
      .catch(function () { /* ignore */ });
  }

  // ── Hook cart-modifying endpoints ──────────────────────────────────────
  var origFetch = window.fetch && window.fetch.bind(window);
  if (origFetch) {
    window.fetch = function (input, init) {
      var url = typeof input === "string" ? input : (input && input.url) || "";
      var p = origFetch(input, init);
      if (/\/cart\/(add|update|change|clear)\.js/.test(url)) {
        p.then(function () { setTimeout(checkCart, 100); }).catch(function () { /* ignore */ });
      }
      return p;
    };
  }
  if (window.XMLHttpRequest) {
    var origOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (method, url) {
      this.__rbUrl = url;
      return origOpen.apply(this, arguments);
    };
    var origSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.send = function () {
      var self = this;
      this.addEventListener("loadend", function () {
        if (self.__rbUrl && /\/cart\/(add|update|change|clear)\.js/.test(self.__rbUrl)) {
          setTimeout(checkCart, 100);
        }
      });
      return origSend.apply(this, arguments);
    };
  }

  function init() { setTimeout(checkCart, 800); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init); else init();
  ["click", "keydown"].forEach(function (ev) {
    document.addEventListener(ev, function (e) {
      var t = e.target && e.target.closest && e.target.closest("[data-cart-drawer-open], .cart-drawer-open, [data-action='open-cart']");
      if (t) setTimeout(checkCart, 500);
    }, true);
  });
})();
